import React, { useEffect } from "react"

import MainLoader from '../../../icons/MainLoader/MainLoader'
import useChangeLoadingScreenTextBasedOnSeconds from '../hooks/useChangeLoadingScreenTextBasedOnSeconds'
import { LOADER_CONFIG_KEYS } from '../../../store/types'


import "../WaitingScreen.scss"

const OfferWaitingPage = () => {
  const { heading, description } = useChangeLoadingScreenTextBasedOnSeconds({ loaderScreenType: LOADER_CONFIG_KEYS.OFFER_WAITING })
  
  return <MainLoader headingText={ heading } descriptionText={ description } />
}

export default OfferWaitingPage